import { AxiosError, AxiosResponse } from 'axios'

export const handleApiResponseError = (err: AxiosError<any>, errorStr: string): AxiosError<any> => {
    if(typeof err.response?.data === 'string') {
        err.response.data = { } as AxiosResponse<any>
            err.response.data.error = errorStr
    }

    return err
}